import React from 'react'

function Svg9(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={12} cy={12} r={8.5} stroke="currentColor" />
      <circle cx={12} cy={12} r={1} fill="currentColor" />
      <circle cx={8} cy={12} fill="currentColor" r={1} />
      <circle cx={16} cy={12} fill="currentColor" r={1} />
    </svg>
  )
}

export default Svg9
